import utils from './utils';

const all = 'all';

const getInvoiceValueToPay = (value, partValue, valueSelectionType) => {
  const valueNumber = !!value ? Number(value) : 0;
  const partValueNumber = !!partValue ? Number(partValue) : 0;
  const valueToPay = valueSelectionType === all ? valueNumber : partValueNumber;
  return valueToPay;
};

const getInvoicesTotalValueToPay = invoices => {
  const value = invoices.reduce((prev, { pendingValue, valueSelectionType, partValue }) => {
    return prev + getInvoiceValueToPay(pendingValue, partValue, valueSelectionType);
  }, 0);
  return value;
};

const getCurrentSupplier = (suppliersGrouping, currentSupplier) => {
  const suppliersIds = Object.keys(suppliersGrouping);
  const supplierId = suppliersIds[currentSupplier];
  const totalSuppliers = suppliersIds.length;

  const {
    info: {
      name,
      businessName,
      email,
      identificationNumber,
      regime,
      bankId,
      accountType,
      accountNumber,
      bankAccountOwnerName,
      bankAccountOwnerIdentificationNumber
    },
    invoices
  } = suppliersGrouping[supplierId];

  const supplier = `${name} - ${businessName}`;
  const confirmationInvoices = invoices.map(({ id, value, partValue, valueSelectionType, valuePending }) => ({
    id,
    value: getInvoiceValueToPay(value, partValue, valueSelectionType),
    valueFormat: utils.moneyFormat(getInvoiceValueToPay(value, partValue, valueSelectionType)),
    valuePending
  }));

  const totalSupplierValue = utils.moneyFormat(getInvoicesTotalValueToPay(invoices));
  const showGoLeftSupplier = currentSupplier > 0;
  const showGoRigthSupplier = currentSupplier < totalSuppliers - 1;

  return {
    totalSuppliers,
    supplier,
    email,
    identificationNumber,
    regime,
    bankId,
    accountType,
    accountNumber,
    bankAccountOwnerName,
    bankAccountOwnerIdentificationNumber,
    confirmationInvoices,
    totalSupplierValue,
    showGoLeftSupplier,
    showGoRigthSupplier
  };
};

const helpers = {
  getInvoiceValueToPay,
  getInvoicesTotalValueToPay,
  getCurrentSupplier
};

export default helpers;
